import React, { Component, ReactNode } from 'react';
import { InformationCircleIcon, WarningTriangleIcon } from '@inter-ikea-kompis/icons';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { localeService } from '../../services';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import HyperLinkColorEnum from '@inter-ikea-kompis/component-hyperlink/lib/enums/HyperlinkColorEnum';
import HyperlinkTargetEnum from '@inter-ikea-kompis/component-hyperlink/lib/enums/HyperlinkTargetEnum';
import styled from 'styled-components';
import { WriteDirection } from 'sofa-reborn-react';

import SkapaModal, {
	Prompt as SkapaPrompt,
	ModalHeader as SkapaModalHeader,
	ModalFooter as SkapaModalFooter,
} from '@ingka/modal';
import SkapaButton from '@ingka/button';
import { KompisIcon, KompisText, KompisHyperlink } from '@inter-ikea-kompis/react-components';

const IconContainer = styled.div<{
	writeDirection: WriteDirection;
	bannerMessageType: string;
}>`
	display: flex;
	padding-right: ${(props) => (props.writeDirection === 'ltr' ? '16px' : 0)};
	padding-left: ${(props) => (props.writeDirection === 'rtl' ? '16px' : 0)};
	color: ${(props) =>
		props.bannerMessageType === 'Cautionary'
			? SkapaTheme.color.semantic.caution
			: SkapaTheme.color.semantic.informative};
`;

const TextLinkContainer = styled.div`
	display: flex;
	flex-direction: column;
`;

const MessageContainer = styled.div`
	display: flex;
`;

type Props = {
	writeDirection: WriteDirection;
	bannerMessageType: string;
	onBannerClose?: () => void;
};

/**
 * React component.
 *
 */
export default class BannerMobile extends Component<Props> {
	/**
	 * React render method.
	 *
	 * @returns React node.
	 */
	public render(): ReactNode {
		const { props } = this;
		const { onBannerClose } = props;
		const bannerIcon =
			props.bannerMessageType === 'Cautionary' ? WarningTriangleIcon : InformationCircleIcon;
		return (
			<SkapaModal visible={true} handleCloseBtn={() => onBannerClose && onBannerClose()}>
				<SkapaPrompt
					titleId={localeService.getTranslation('plannerBannerMessageTitle')}
					title={localeService.getTranslation('plannerBannerMessageTitle')}
					header={<SkapaModalHeader />}
					footer={
						<SkapaModalFooter>
							<SkapaButton
								type={'primary'}
								fluid={true}
								text={localeService.getTranslation('tooltipDismissButtonLabel')}
							/>
						</SkapaModalFooter>
					}
				>
					<MessageContainer>
						<IconContainer
							writeDirection={props.writeDirection}
							bannerMessageType={props.bannerMessageType}
						>
							<KompisIcon theme={SkapaTheme} icon={bannerIcon || ''}></KompisIcon>
						</IconContainer>
						<TextLinkContainer>
							<KompisText theme={SkapaTheme} type={ThemeFontStyleTypeEnum.bodyMedium}>
								<KompisHyperlink
									theme={SkapaTheme}
									target={HyperlinkTargetEnum.blank}
									color={HyperLinkColorEnum.black}
									text={localeService.getTranslation('plannerBannerMessageLinkText')}
									href={localeService.getUrl('plannerBannerMessageLinkURL')}
								></KompisHyperlink>
							</KompisText>
						</TextLinkContainer>
					</MessageContainer>
				</SkapaPrompt>
			</SkapaModal>
		);
	}
}
